"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SingleCell = exports.PaddedDoubleContentCell = exports.PaddedContentCell = exports.MonogramCell = exports.Monogram = exports.DoubleCell = exports.DateCell = exports.Cells = exports.Cell = exports.BasicSingleCell = exports.BasicDoubleCell = void 0;
var React = _interopRequireWildcard(require("react"));
var _formatDistance = _interopRequireDefault(require("date-fns/formatDistance"));
var _parseISO = _interopRequireDefault(require("date-fns/parseISO"));
var _classify = require("../../utils/classify");
var _makeClassNameComponent = require("../../utils/makeClassNameComponent");
var _qa = require("../../utils/qa");
var _Avatar = require("../Avatar");
var _Text = require("../Text");
var _TableModule = _interopRequireDefault(require("./Table.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Cells = _ref => {
  let {
    children,
    className,
    testId,
    ...rest
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _classify.classify)(_TableModule.default.row, className),
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'cells'
    }),
    ...rest,
    children: children
  });
};
exports.Cells = Cells;
const Cell = _ref2 => {
  let {
    children,
    className,
    testId
  } = _ref2;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _classify.classify)(_TableModule.default.cell, className),
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'cell'
    }),
    children: children
  });
};
exports.Cell = Cell;
const BasicSingleCell = exports.BasicSingleCell = (0, _makeClassNameComponent.makeClassNameComponent)(_TableModule.default.defaultSingleCell, 'td');
const BasicDoubleCell = exports.BasicDoubleCell = (0, _makeClassNameComponent.makeClassNameComponent)(_TableModule.default.defaultDoubleCell, 'td');
const PaddedContentCell = exports.PaddedContentCell = (0, _makeClassNameComponent.makeClassNameComponent)(_TableModule.default.singleContentCell, 'td');
const PaddedDoubleContentCell = exports.PaddedDoubleContentCell = (0, _makeClassNameComponent.makeClassNameComponent)(_TableModule.default.doubleContentCell, 'td');
const SingleCell = _ref3 => {
  let {
    title,
    className,
    testId
  } = _ref3;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(PaddedContentCell, {
    className: className,
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'single-cell'
    }),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.BodyMedium, {
      className: _TableModule.default.paddedTitleBlock,
      children: title
    })
  });
};
exports.SingleCell = SingleCell;
const DoubleCell = _ref4 => {
  let {
    title,
    subtitle,
    className,
    testId
  } = _ref4;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(PaddedDoubleContentCell, {
    className: className,
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'double-cell'
    }),
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _TableModule.default.paddedTitleBlock,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.BodyMedium, {
        className: _TableModule.default.doubleTitle,
        children: title
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.BodySmall, {
        color: _Text.TEXT_COLORS.tertiary,
        className: _TableModule.default.doubleSubtitle,
        children: subtitle ?? ''
      })]
    })
  });
};
exports.DoubleCell = DoubleCell;
const DateCell = _ref5 => {
  let {
    date,
    className,
    testId
  } = _ref5;
  const parsedDate = typeof date === 'object' ? date : (0, _parseISO.default)(date);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(DoubleCell, {
    title: `${parsedDate.getMonth() + 1} / ${parsedDate.getDate() + 1} / ${parsedDate.getFullYear()}`,
    subtitle: `${(0, _formatDistance.default)(parsedDate, new Date())} ago`,
    className: className,
    testId: testId
  });
};
exports.DateCell = DateCell;
const Monogram = _ref6 => {
  let {
    initials,
    testId
  } = _ref6;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Avatar.Avatar, {
    size: "small",
    text: initials,
    testId: testId
  });
};
exports.Monogram = Monogram;
const MonogramCell = _ref7 => {
  let {
    initials,
    className,
    testId
  } = _ref7;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(PaddedContentCell, {
    className: className,
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'monogram-cell'
    }),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Monogram, {
      initials: initials,
      testId: testId
    })
  });
};
exports.MonogramCell = MonogramCell;